import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';


var discussion = "";


export default class DiscussionGalleryImages extends Component {

    static gallery = null;

    oninit(vnode) {
        discussion = vnode.attrs.discussion;
        const slug = discussion.slug().split("-");

        //send get request for images
        this.imageXHR(slug[0], 999);
    }


    view() {
        $('h1.DiscussionHero-title').html(discussion.title() + ' képgaléria');
       return this.gallery;
    }


    //get request
    imageXHR(id, limit) {
        const items = new ItemList();

        m.request({
            method: "GET",
            url: "https://m500.pazirikkft.hu/teszt.php",
            async: true,
            withCredentials: true,
            responseType: "json",
            params: {id: id, limit: limit}
        })
        .then((result) => {
            this.gallery = this.imageGallery(result.data);
        })
    }



    //generate gallery html
    imageGallery(imageArray) {
    
        var mArray = new Array();
    
        imageArray.forEach(element => {
            mArray.push(
                //m("li", {}, [
                    m("a", { href: element, 'data-fancybox': 'topic-gallery' }, 
                     [
                        m("img", { src: element })
                    ])
                //])
            );
        });

    
        return m("div", { class: "topic-gallery" }, [
            m("div", { class: "topic-gallery-images" }, mArray)
        ]);
    
    }

}